import { Component, Input } from '@angular/core';
import { HxUiLabelPipe, InvoiceProductModel } from 'hx-services';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-invoice-product',
    templateUrl: './invoice-product.component.html',
    styleUrls: ['./invoice-product.component.css'],
    imports: [NgIf, HxUiLabelPipe]
})
export class InvoiceProductComponent {
  @Input() product: InvoiceProductModel;
}
